// @ts-nocheck
import { getWarrantyBySerial } from "@store/Framework/Services/Pages/ProductWarrantyLookup/ProductWarrantyLookupService";
import { WarrantyResult } from "@store/Framework/Types/ApiModels";
import { ApiHandler, createHandlerChainRunner } from "@toolkit/Modules/client-framework/HandlerCreator";

type GetWarrantyBySerialParameter = {
    serialNumber: string;
};

type HandlerType = ApiHandler<GetWarrantyBySerialParameter, WarrantyResult>;

export const DispatchBeginWarrantyLookup: HandlerType = props => {
    props.dispatch({
        type: "Store/Pages/ProductCatalogs/BeginWarrantyLookup",
    });
};

export const HandleSearchQuery: HandlerType = props => {
    const { dispatch } = props;
    dispatch({
        type: "Store/Pages/ProductWarrantyLookup/SetSearchQuery",
        searchQuery: props.parameter.serialNumber,
    });
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getWarrantyBySerial(props.parameter.serialNumber);
};

export const DispatchCompleteSetWarrantyModel: HandlerType = props => {
    const { dispatch, apiResult } = props;
    switch (apiResult.type) {
        case 0:
            dispatch({
                type: "Store/Pages/ProductWarrantyLookup/SetModels",
                response: apiResult,
            });
            break;
        case 1:
            dispatch({
                type: "Store/Pages/ProductWarrantyLookup/SetWarranty",
                response: apiResult,
            });
            break;
        default:
            dispatch({
                type: "Store/Pages/ProductWarrantyLookup/SetModels",
                response: apiResult,
            });
    }
};

export const chain = [
    DispatchBeginWarrantyLookup,
    HandleSearchQuery,
    RequestDataFromApi,
    DispatchCompleteSetWarrantyModel,
];

const findWarrantyBySerial = createHandlerChainRunner(chain, "FindWarrantyBySerial");
export default findWarrantyBySerial;
